export const PLANS = {
  monthly: { price: 12.99, label: "/month", cta: "$12.99/mo", name: "CLAWBACK MONTHLY", note: "If we recover less than $13 this month, next month is free." },
  yearly: { price: 99, label: "/year", cta: "$99/yr", name: "CLAWBACK YEARLY", note: "$8.25/month billed once a year — save $57 vs monthly.", badge: "save $57" },
};

export default function PlanToggle({ plan, onChange, testid = "plan-toggle" }) {
  return (
    <div className="inline-flex items-center rounded-full border border-[#282C30] bg-[#0C0D0E] p-1 font-mono text-[11px] uppercase tracking-widest" data-testid={testid}>
      {["monthly", "yearly"].map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`px-3 py-1.5 rounded-full transition-colors duration-200 ${plan === p ? "bg-[#00E676] text-[#001b09]" : "text-[#A0A7B0] hover:text-[#F4F1EA]"}`}
          data-testid={`${testid}-${p}`}
        >
          {p}{p === "yearly" && <span className={`ml-1.5 ${plan === p ? "text-[#001b09]/70" : "text-[#00E676]"}`}>−36%</span>}
        </button>
      ))}
    </div>
  );
}
